// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__2GEXK","content":"GlobalSearch_content__1KrjI"};